module.exports = __webpack_public_path__ + "static/assets/ebdda865bfeccf708d3eb26a6ae6a724.jpg";